
module.exports = {
	Generator: require('./src/jsCalendar'),
	addLabels: require('./src/addLabels')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/js-calendar/index.js
// module id = 420
// module chunks = 0